export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11430.2a9e0f4e.jpg";